import { render, staticRenderFns } from "./Salden.vue?vue&type=template&id=0eefbcec&scoped=true"
import script from "./Salden.vue?vue&type=script&lang=ts"
export * from "./Salden.vue?vue&type=script&lang=ts"
import style0 from "./Salden.vue?vue&type=style&index=0&id=0eefbcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eefbcec",
  null
  
)

export default component.exports